<!-- 零售出库 -->
<template>
  <article class="out_bound">
    <section  v-if="!showSeller">
      <group :title="list.title" v-for="(list, index) in inputLists" :key="index">
        <p class="out_item_hint out_item_title" v-if="list.hint">{{list.hint}}</p>
        <x-input v-if="index === 0"  class="deal_date" v-model="sellerName" placeholder="请选择提供信息人员" is-link  :readonly="true" @click.native="sellerSub">
          <div slot="label"><span class="vux-label-desc">*</span>销售人员</div>
        </x-input>
        <datetime
          v-if="index === 0"
          v-model="formData.transaction_date"
          title="成交日期"
          placeholder="请选择日期"
          confirm-text="确定"
          cancel-text="取消"
          inline-desc="*"
          @on-change="change"
          class="deal_date">
        </datetime>
        <div class="out_bound_item" v-for="item in list.value" :key="item.name">
          <x-input
            v-if="!item.disabled"
            v-model="formData[item.name]"
            :name="item.name"
            :placeholder="item.placeholder"
            :required="item.required"
            :is-type="item.validate"
            :keyboard="item.type"
            :max="11"
            :class="{'price-verify': item.verify}">
            <div slot="label"><span class="red_dots" v-if="item.required">*</span>{{item.title}}</div>
            <span slot="right">{{item.unit}}</span>
          </x-input>
          <!-- 用于存储四个计算公式值的input -->
          <x-input
            v-if="item.disabled"
            v-model="calculateData[item.name]"
            :required="item.required"
            :disabled="item.disabled">
              <div slot="label"><span class="red_dots" v-if="item.required">*</span>{{item.title}}</div>
              <span slot="right">{{item.unit}}</span>
          </x-input>
          <p class="out_item_hint" v-if="item.hint">{{item.hint}}</p>
        </div>
      </group>

      <group title="备注">
        <x-textarea
          v-model="formData.remark"
          :max="255"
          :show-counter="true"
          placeholder="请输入内容（非必填）">
        </x-textarea>
      </group>
      <upload-pic
        :images.sync="formData.images"
        :dragable="imagesConfig.dragable"
        :count="imagesConfig.length"
        @upload="ImgUpload"
        @delete="ImgDelete">
        <p class="title">{{imagesConfig.title}}</p>
      </upload-pic>
      <footer-btn title="提交" :isReady="!allValidate" @submit="onSubmit()"></footer-btn>
    </section>
    <SelectorList
      v-model="showSeller"
      :checked="formData.employee_id"
      :roleList="roleList"
      @commit="changeEmp">
    </SelectorList>
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“元”，你所输入的以下金额小于100元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </article>
</template>

<script>
import { Group, XTextarea, Datetime, XInput, SelectorList, XAlert, UploadPic } from '@lx-frontend/cvux'
import FooterBtn from '../components/FooterBtn'
import util from '../../common/util'
import cache from '../../common/cache'
import { Decimal } from 'decimal.js'

export default {
  components: {
    Group,
    XTextarea,
    Datetime,
    XInput,
    UploadPic,
    FooterBtn,
    SelectorList,
    XAlert
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      dialogContent: [], // 提示文本
      carId: '',
      scrolltop: 0, // 选择人滚动前位置
      showSeller: false, // 是否展示销售人员列表窗口
      sellerName: '', // 销售人员
      roleList: [], // 销售人员列表
      validForm: { // 需校验项
        employee_id: false,
        transaction_date: false,
        deal_price: false, // 零售成交价
        car_cost: false, // 收车合同价
        maintenance_cost: false, // 整备费用
        transfer_fee: false, // 过户费
        other_cost: false, // 其他费用
        car_income: false, // 车辆收入/水平总收入
        car_gross_profit: false, // 水平总成本
        buyer_mobile: false,
        buyer_name: false
      },
      formData: {
        employee_id: '', // 销售人员
        transaction_date: '', // 成交日期
        deal_price: '', // 零售成交价
        car_cost: '', // 收车合同价
        maintenance_cost: '', // 整备费用
        transfer_fee: '', // 过户费
        other_cost: '', // 其他费用
        car_income: '', // 车辆收入/水平总收入
        car_gross_profit: '', // 水平总成本
        buyer_mobile: '',
        buyer_name: '',
        remark: '',
        images: [
          { src: '', name: '身份证正面', code: 'id_card_a' },
          { src: '', name: '身份证反面', code: 'id_card_b' },
          { src: '', name: '销售合同', code: 'contract' },
          { src: '', name: '收款信息', code: 'receipt' },
          { src: '', name: '出库单', code: 'outbound_doc' }
        ]
      },
      priceKeys: ['deal_price', 'car_cost', 'maintenance_cost', 'transfer_fee', 'other_cost', 'car_income', 'car_gross_profit'],
      imagesConfig: {
        requestUrl: 'getImageByAuction',
        dragable: false,
        title: '凭证照片（如合同、收款信息、买家身份证等）',
        length: 15,
        initImagesLength: 0
      }
    }
  },
  created() {
    this.inputLists = [
      { title: '零售情况',
        value: [{
          title: '零售成交价格', // 标题名
          name: 'deal_price',
          placeholder: '不含水平业务收入', // placeholdor
          unit: '元', // 单位
          type: 'text', // 输入类型
          validate: this.val_price,
          required: true, // 是否必填
          verify: false // 是否做价格提示
        }, {
          title: '零售收入',
          name: 'retail_income',
          placeholder: '',
          unit: '元',
          type: 'text',
          disabled: true,
          hint: '(零售收入=零售成交价格+水平总收入)'
        }, {
          title: '零售综合毛利',
          name: 'retail_gross_profit',
          placeholder: '',
          unit: '元',
          type: 'text',
          disabled: true,
          hint: '(零售综合毛利=零售成交价格+水平总毛利-收车合同价-成本费用合计)'
        }]
      }, {
        title: '收车成本',
        value: [{
          title: '收车合同价',
          name: 'car_cost',
          placeholder: '请输入 ',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }]
      }, {
        title: '零售成本',
        hint: '(由于零售产生的成本费用)',
        value: [{
          title: '整备费用',
          name: 'maintenance_cost',
          placeholder: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }, {
          title: '过户费',
          name: 'transfer_fee',
          placeholder: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }, {
          title: '其他费用',
          name: 'other_cost',
          placeholder: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }, {
          title: '成本费用合计',
          name: 'all_cost',
          placeholder: '',
          unit: '元',
          type: 'text',
          disabled: true,
          hint: '(成本费用合计=整备费用+过户费+其他费用)'
        }]
      }, {
        title: '水平业务收益',
        hint: '(包括金融、保险、延保、用品、粘合度产品等水平业务)',
        value: [{
          title: '水平总收入',
          name: 'car_income',
          placeholder: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }, {
          title: '水平总成本',
          name: 'car_gross_profit',
          placeholder: '请输入',
          unit: '元',
          type: 'text',
          validate: this.val_price,
          required: true,
          verify: false // 是否做价格提示
        }, {
          title: '水平总毛利',
          name: 'car_gross_all',
          placeholder: '',
          unit: '元',
          type: 'text',
          disabled: true,
          hint: '(水平总毛利=水平总收入-水平总成本)'
        }]
      }, {
        title: '客户信息',
        value: [{
          title: '买家姓名',
          name: 'buyer_name',
          placeholder: '请输入',
          unit: '',
          type: 'text',
          validate: this.val_owner_name,
          required: true
        }, {
          title: '买家电话',
          name: 'buyer_mobile',
          placeholder: '请输入',
          unit: '',
          type: 'number',
          validate: this.val_owner_mobile,
          required: true
        }]
      }
    ]
    let lastFormData = cache.getSessionData('OUTBOUND_FROM_DATA')
    this.carId = this.$route.params.id
    if (lastFormData) {
      this.sellerName = lastFormData.employee_name
      this.formData = this.getFormatData(lastFormData)
      this.validForm.transaction_date = true
    } else {
      this.$rest.auction.getVehicleCarDetail(null, this.carId).then((res) => {
        if (res.code === 0) {
          let price = res.data.contract_price
          if (price) {
            this.formData.car_cost = new Decimal(price).div(100).toNumber()
          }
        } else {
          this.showToast(res.message)
        }
      })
    }
    if (this.formData.images.length >= 0) this.imagesConfig.initImagesLength = this.formData.images.length - 1
  },
  mounted() {
    this.getSeller()
  },
  methods: {
    getFormatData(data) {
      // 价格单位转换回填
      this.priceKeys.forEach(v => {
        data[v] = (data[v] / 100).toFixed(2)
      })
      // 照片回填
      if (data.images.length > 0) {
        let imgList = [...this.formData.images].reverse()
        imgList.forEach(v => {
          let item = data.images.find(item => {
            return item.code === v.code
          })
          if (!item) data.images.unshift(v)
        })
      } else {
        data.images = this.formData.images
      }
      return data
    },
    postData() {
      // 处理单位为分
      let formatData = {}
      this.priceKeys.forEach(v => {
        let value = +this.formData[v]
        formatData[v] = new Decimal(value).mul(100).toNumber()
      })
      formatData.images = this.formData.images.filter(v => {
        return v.src
      })
      let params = { ...this.formData, ...formatData }
      this.$rest.outBound.postRetail(params, this.carId).then(res => {
        if (res.code === 0) {
          this.$router.push(`/outbound/succ/${res.data.id}`)
        } else {
          this.showToast(res.message)
        }
      })
    },
    getSeller() { // 获取销售人员列表
      this.switchLoading({ status: true, text: '加载中...' })
      this.$rest.outBound.getRetailEmployees().then(res => {
        if (res.code === 0) {
          let data = this.roleList = res.data
          data.forEach((val, index) => {
            if (val.roles.length) {
              this.roleList[index].roles = this.roleList[index].roles.join('、')
            } else {
              this.roleList[index].roles = '该用户暂未配置角色权限'
            }
          })
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    sellerSub() { // 展示销售人员列表
      this.scrolltop = window.scrollY
      this.showSeller = true
    },
    changeEmp(checked, name) { // 选择销售人员
      this.formData.employee_id = checked
      this.validForm.employee_id = true
      this.sellerName = name
      window.scrollTo(0, this.scrolltop)
    },
    // 以下三个函数为校验规则函数
    val_price(val, name) {
      let valid = util.regexpMap.regexp_price.test(val)
      let result = this.validate(valid, '请输入有效的价格，小数点最多保留两位')
      this.validForm[name] = valid // 即时存储表单校验结果
      if (!result.valid) {
        this.showToast(result.msg)
      }
      // 组件input的isType自定义函数，需要返回包含布尔值valid和msg这两个属性的对象
      return result
    },
    val_owner_name(val, name) {
      // 校验车主姓名，可以是企业名称，限制为字符长度60
      let byteLength = util.getByteLen(val)
      let valid = (byteLength >= 4 && byteLength <= 60)
      this.validForm[name] = valid
      return this.validate(valid, '请输入有效的联系人名字')
    },
    val_owner_mobile(val, name) {
      let valid = util.regexpMap.regexp_mobile.test(val)
      this.validForm[name] = valid
      return this.validate(valid, '请输入有效的电话号码')
    },
    validate(valid, msg) {
      return { valid: valid, msg: msg }
    },
    change(val) {
      this.validForm.transaction_date = true
    },
    onSubmit() {
      // 判断必填项是否已全部填完，若填完提交按钮高亮并能提交
      if (this.allValidate) {
        if (this.isVerify) {
          const ispass = this.priceVerify()
          if (!ispass) {
            return false
          }
        }
        this.postData()
      } else {
        this.showToast('请将必填信息填写完整后再提交')
      }
    },
    // 金额防错提示
    priceVerify() {
      const priceVerifyArr = [{
        key: 'deal_price',
        tpl: `零售成交价格：${this.formData.deal_price}元`
      }, {
        key: 'car_cost',
        tpl: `收车合同价：${this.formData.car_cost}元`
      }, {
        key: 'maintenance_cost',
        tpl: `整备费用：${this.formData.maintenance_cost}元`
      }, {
        key: 'transfer_fee',
        tpl: `过户费：${this.formData.transfer_fee}元`
      }, {
        key: 'other_cost',
        tpl: `其他费用：${this.formData.other_cost}元`
      }, {
        key: 'car_income',
        tpl: `水平总收入：${this.formData.car_income}元`
      }, {
        key: 'car_gross_profit',
        tpl: `水平总成本：${this.formData.car_gross_profit}元`
      }]
      for (let i = 0, len = priceVerifyArr.length; i < len; i++) {
        let item = priceVerifyArr[i]
        if (this.formData[item.key] < 100) {
          this.toggleVerify(item.key)
          this.dialogContent.push(item.tpl)
        }
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    },
    toggleVerify(name) {
      for (let i = 0, len = this.inputLists.length; i < len; i++) {
        const obj = this.inputLists[i]
        for (let j = 0, length = obj.value.length; j < length; j++) {
          const item = obj.value[j]
          if (item.name === name) {
            this.inputLists[i].value[j].verify = true
            break
          }
        }
      }
    },
    ImgUpload(i) {
      let iamges = this.formData.images
      this.$wechat.imgUpLoad(this, i, iamges, this.imagesConfig.requestUrl)
    },
    ImgDelete(i) {
      let iamges = this.formData.images
      this.$wechat.imgDelete(i, iamges, this.imagesConfig.initImagesLength)
    }
  },
  computed: {
    allValidate () {
      let isValid = true
      let keys = Object.keys(this.validForm)
      let values = Object.values(this.validForm)

      // 判断必填项是否有值
      for (let i = 0, len = keys.length; i < len; i++) {
        if (!this.formData[keys[i]]) {
          isValid = false
          break
        }
      }
      // 校验必填项
      for (let i = 0, len = values.length; i < len; i++) {
        if (!values[i]) {
          isValid = false
          break
        }
      }
      return isValid
    },
    // 计算合集
    calculateData () {
      // (水平总毛利=水平总收入-水平总成本)
      let carGrossAll = new Decimal(+this.formData.car_income).minus(+this.formData.car_gross_profit).toNumber() || 0
      // (成本费用合计=整备费用+过户费+其他费用)
      let allCost = new Decimal(+this.formData.maintenance_cost).plus(+this.formData.transfer_fee).plus(+this.formData.other_cost).toNumber() || ''
      // (零售收入=零售成交价格+水平总收入)
      let retailIncome = new Decimal(+this.formData.deal_price).plus(+this.formData.car_income).toNumber() || ''
      // (零售综合毛利=零售成交价格+水平总毛利-收车实价-成本费用合计)
      let retailGrossProfit = new Decimal(+this.formData.deal_price).plus(+carGrossAll).minus(+this.formData.car_cost).minus(+allCost).toNumber() || ''
      return {
        retail_income: retailIncome,
        retail_gross_profit: retailGrossProfit,
        all_cost: allCost,
        car_gross_all: carGrossAll
      }
    }
  },
  watch: {
    'formData.employee_id'(val) {
      // 销售人员employee_id字段单独判断
      let validEmployee = false
      if (VAL) {
        validEmployee = true
      }
      this.validForm.employee_id = validEmployee
    }
  }
}
</script>

<style lang="less">
@import '../../stylesheets/base/fn';
@import '../../stylesheets/base/mixin/common.less';
.out_bound {
  position: relative;
  .selector-list{
    .weui_cell_hd {
      width: auto;
    }
  }
  .weui_cell_hd{width: 210/@w2;}
  .deal_date {
    .weui_cell_bd{
      width: 210/@w2;
      overflow: hidden;
      p{display: inline-block;}
    }
    .vux-label-desc {
      color: red;
      float: left;
    }
  }
  .red_dots{color: red;}

  .weui_cells {
    &:before {
      display: none;
    }
    &:after {
      display: none;
    }
  }
  .out_item_hint {
    padding: 16/@w2 30/@w2 30/@w2;
    line-height: 1;
    font-size: 20/@w2;
    color: #999;
    background-color: #eee;
  }
  .out_item_title {
    padding: 0 30/@w2 16/@w2;
  }
  .out_bound_item{
    .weui_cell{
      &:before { display: initial;}
    }
    .weui_cell:last-child {
      .out_item_hint{padding-bottom: 0;}
    }
  }
  .out_bound_item:first-of-type{
    .weui_cell{
      &:before {display: none;}
    }
  }
}
.single_check_list{
  .check_item{
    width: 100%;
    font-size: 30/@w2;
    line-height: 1.8;
    padding: 30/@w2;
    box-sizing: border-box;
    border-bottom: 1px solid #eeeeee;
    position: relative;

    &:last-child{
      border-bottom: none;
    }

    .check_item_name {
      width: 200/@w2;
      display: inline-block;
    }
    .check_item_icon{
      position: absolute;
      right: 30/@w2;
      top: 50%;
      transform: translateY(-50%);
      width: 34/@w2;
      height: 34/@w2;
      border: 1px solid #e7e7e7;
      border-radius: 50%;
      box-sizing: border-box;
    }
  }

  .check_item_selected{
    .check_item_icon {
      background: #509eff;
      border: 6/@w2 solid #fff;
      box-shadow: 0 0 0 1px #509eff;
    }
  }
}
</style>
